import styled, { css } from 'styled-components';
import { Palette } from 'config';
import { appStatuses } from 'constants';
import { Link } from 'react-router-dom';

export const StatusWrapp = styled.div`
  display: flex;
  align-items: center;
  svg {
    margin-right: 8px;
    fill: ${() => Palette.PrimaryGray._400};
    min-height: 16px;
    min-width: 16px;
  }
  font-weight: 400;
  ${({ status }) => statusLayout(status)}
`;

export const MyLink = styled(Link)`
  color: ${() => Palette.Primary._500};
  cursor: pointer;
  margin-left: 3px;
  text-decoration: none;
`;

export const MyA = styled(MyLink).attrs({ as: 'a' })``;

export const AwaitingStatusWrap = styled.span`
  color: ${Palette.Red._500};
  margin-right: 3px;
`;

const statusLayout = (status) => {
  switch (status) {
    case appStatuses.promoting: {
      return css`
        color: ${() => Palette.Emerald._500};
        font-size: 12px;
        line-height: 16px;
      `;
    }
    case appStatuses.ready_to_promote: {
      return css`
        color: ${() => Palette.Amber._500};
        font-size: 14px;
        line-height: 20px;
        span {
          color: ${() => Palette.PrimaryGray._700};
        }
      `;
    }
    case appStatuses.archived: {
      return css`
        color: ${() => Palette.PrimaryGray._700};
        font-size: 14px;
        line-height: 20px;
      `;
    }
    case appStatuses.monetising: {
      return css`
        color: ${() => Palette.Emerald._500};
        font-size: 12px;
        line-height: 16px;
      `;
    }
    default:
      return css`
        color: ${() => Palette.PrimaryGray._700};
        font-size: 14px;
        line-height: 20px;
      `;
  }
};
